<template>
    <div>
        <div class="row">
          <div class="col-12">
            <div class="card-title">
              <h5 class="float-left">Billing Rules</h5>
              <b-button variant="primary" class="btn btn-label btn-primary float-right" v-b-modal.modal_addField><i class='bx bx-plus label-icon'></i>Add Rule</b-button>
              <!-- <b-modal id="modal_addField" title="Add Field" title-class="font-18" ok-title="Add Field" @ok="addField">
                <div class="mb-4">
                  <div class="form-group">
                    <label id="lbl_addField_name">Name <i class="bx bxs-help-circle"></i></label>
                    <b-tooltip target="lbl_addField_name">The name is a unique identifier for the field. This is not shown anywhere on the mobile or web application</b-tooltip>
                    <b-form-input 
                      placeholder="Name..." 
                      v-model="addField_name"
                      :class="{ 'is-invalid': addField_errors.nameError }"
                    ></b-form-input>
                    <div v-if="addField_errors.nameError" class="invalid-feedback">
                      <span>{{addField_errors.nameMessage}}</span>
                    </div>
                  </div>
                </div>
                <div class="mb-4">
                  <div class="form-group">
                    <label id="lbl_addField_label">Label <i class="bx bxs-help-circle"></i></label>
                    <b-tooltip target="lbl_addField_label">The label is the text that is shown above the form field in the web app and mobile app</b-tooltip>
                    <b-form-input 
                      placeholder="Label..." 
                      v-model="addField_label"
                      :class="{ 'is-invalid': addField_errors.labelError }"
                    ></b-form-input>
                    <div v-if="addField_errors.labelError" class="invalid-feedback">
                      <span>{{addField_errors.labelMessage}}</span>
                    </div>
                  </div>
                </div>
                <div class="mt-4 mt-lg-0 mb-4">
                  <div class="form-group">
                    <label id="lbl_addField_type">Type <i class="bx bxs-help-circle"></i></label>
                    <b-tooltip target="lbl_addField_type">The field type will determine how the field looks and what values will be allowed to be inputted in it.</b-tooltip>
                    <v-select  
                      :options="fieldTypes" 
                      label="position" 
                      v-model="addField_selectedType"
                      :class="{ 'is-invalid ddl-is-invalid': addField_errors.typeError }"
                    ></v-select>
                    <div v-if="addField_errors.typeError" class="invalid-feedback">
                      <span>{{addField_errors.typeMessage}}</span>
                    </div>
                  </div>
                </div>
                <div class="mt-4 mt-lg-0 mb-4">
                  <div class="form-group">
                    <b-form-checkbox
                        v-model="addField_mobile"
                        value="true"
                        unchecked-value="false"
                        class="custom-checkbox custom-control-right"
                        checked
                    >Show field on mobile application <i id="lbl_addField_mobile" class="bx bxs-help-circle"></i></b-form-checkbox>
                    <b-tooltip target="lbl_addField_mobile">The label is the text that is shown above the form field in the web app and mobile app</b-tooltip>
                  </div>
                </div>
                <div class="mt-4 mt-lg-0 mb-4">
                  <div class="form-group">
                    <b-form-checkbox
                        v-model="addField_web"
                        value="true"
                        unchecked-value="false"
                        class="custom-checkbox custom-control-right"
                        checked
                    >Show field on web application <i id="lbl_addField_web" class="bx bxs-help-circle"></i></b-form-checkbox>
                    <b-tooltip target="lbl_addField_web">The label is the text that is shown above the form field in the web app and mobile app</b-tooltip>
                  </div>
                </div>
                <div class="mt-4 mt-lg-0 mb-4">
                  <div class="form-group">
                    <b-form-checkbox
                        v-model="addField_required"
                        value="true"
                        unchecked-value="false"
                        class="custom-checkbox custom-control-right"
                        checked
                    >Field required <i id="lbl_addField_required" class="bx bxs-help-circle"></i></b-form-checkbox>
                    <b-tooltip target="lbl_addField_required">If this value is unchecked, then the user will not be required to fill out this field when entering a time</b-tooltip>
                  </div>
                </div>
              </b-modal>
              <b-modal id="modal_editField" title="Edit Field" title-class="font-18" ok-title="Submit" @ok="submitEditField">
                <div class="mb-4">
                  <div class="form-group">
                    <label id="lbl_editField_name">Name <i class="bx bxs-help-circle"></i></label>
                    <b-tooltip target="lbl_editField_name">The name is a unique identifier for the field. This is not shown anywhere on the mobile or web application. This field cannot be edited.</b-tooltip>
                    <b-form-input 
                      disabled
                      placeholder="Name..." 
                      v-model="editField_name"
                      :class="{ 'is-invalid': editField_errors.nameError }"
                    ></b-form-input>
                    <div v-if="editField_errors.nameError" class="invalid-feedback">
                      <span>{{editField_errors.nameMessage}}</span>
                    </div>
                  </div>
                </div>
                <div class="mb-4">
                  <div class="form-group">
                    <label id="lbl_editField_label">Label <i class="bx bxs-help-circle"></i></label>
                    <b-tooltip target="lbl_editField_label">The label is the text that is shown above the form field in the web app and mobile app</b-tooltip>
                    <b-form-input 
                      placeholder="Label..." 
                      v-model="editField_label"
                      :class="{ 'is-invalid': editField_errors.labelError }"
                    ></b-form-input>
                    <div v-if="editField_errors.labelError" class="invalid-feedback">
                      <span>{{editField_errors.labelMessage}}</span>
                    </div>
                  </div>
                </div>
                <div class="mt-4 mt-lg-0 mb-4">
                  <div class="form-group">
                    <label id="lbl_editField_type">Type <i class="bx bxs-help-circle"></i></label>
                    <b-tooltip target="lbl_editField_type">The field type will determine how the field looks and what values will be allowed to be inputted in it.</b-tooltip>
                    <v-select  
                      :options="fieldTypes" 
                      label="position" 
                      v-model="editField_selectedType"
                      :class="{ 'is-invalid ddl-is-invalid': editField_errors.typeError }"
                    ></v-select>
                    <div v-if="editField_errors.typeError" class="invalid-feedback">
                      <span>{{editField_errors.typeMessage}}</span>
                    </div>
                  </div>
                </div>
                <div class="mt-4 mt-lg-0 mb-4">
                  <div class="form-group">
                    <b-form-checkbox
                        v-model="editField_mobile"
                        value="true"
                        unchecked-value="false"
                        class="custom-checkbox custom-control-right"
                        checked
                    >Show field on mobile application <i id="lbl_editField_mobile" class="bx bxs-help-circle"></i></b-form-checkbox>
                    <b-tooltip target="lbl_editField_mobile">The label is the text that is shown above the form field in the web app and mobile app</b-tooltip>
                  </div>
                </div>
                <div class="mt-4 mt-lg-0 mb-4">
                  <div class="form-group">
                    <b-form-checkbox
                        v-model="editField_web"
                        value="true"
                        unchecked-value="false"
                        class="custom-checkbox custom-control-right"
                        checked
                    >Show field on web application <i id="lbl_editField_web" class="bx bxs-help-circle"></i></b-form-checkbox>
                    <b-tooltip target="lbl_editField_web">The label is the text that is shown above the form field in the web app and mobile app</b-tooltip>
                  </div>
                </div>
                <div class="mt-4 mt-lg-0 mb-4">
                  <div class="form-group">
                    <b-form-checkbox
                        v-model="editField_required"
                        value="true"
                        unchecked-value="false"
                        class="custom-checkbox custom-control-right"
                        checked
                    >Field required <i id="lbl_editField_required" class="bx bxs-help-circle"></i></b-form-checkbox>
                    <b-tooltip target="lbl_editField_required">If this value is unchecked, then the user will not be required to fill out this field when entering a time</b-tooltip>
                  </div>
                </div>
              </b-modal> -->
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-8">
           <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select v-model="formItemsPerPage" size="sm" :options="formItemsPageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="formItemsFilter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="formItemsTableData"
                :fields="formItemsFields"
                responsive="sm"
                :per-page="formItemsPerPage"
                :current-page="formItemsCurrentPage"
                :sort-by.sync="formItemsSortBy"
                :sort-desc.sync="formItemsSortDesc"
                :filter="formItemsFilter"
                :filter-included-fields="formItemsFilterOn"
              >
                <template v-slot:cell(edit)="data">
                  <b-dropdown variant="primary" size="sm">
                    <template v-slot:button-content>
                      <i class="mdi mdi-chevron-down"></i>
                    </template>
                    <b-dropdown-item @click="moveFieldUp(data.item.order)" :disabled="data.item.order == 0" ><i class='bx bx-up-arrow-alt mr-2 tableIcons'></i>Move Up</b-dropdown-item>
                    <b-dropdown-item @click="moveFieldDown(data.item.order)" :disabled="data.item.order == formItemsTableData.length-1"><i class='bx bx-down-arrow-alt mr-2 tableIcons'></i>Move Down</b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item v-b-modal.modal_editField @click="editField(data.index, data.item.edit, data.item.name, data.item.label, data.item.type, data.item.mobile, data.item.web, data.item.required)" :disabled="nonDeleteFields.includes(data.item.name)"><i class='bx bx-pencil mr-2 tableIcons'></i>Edit</b-dropdown-item>
                    <b-dropdown-item @click="deleteField(data.item.edit)" :disabled="nonDeleteFields.includes(data.item.name)"><i class='bx bx-trash mr-2 tableIcons'></i>Delete</b-dropdown-item>
                  </b-dropdown>
                </template>
                <template v-slot:cell(position)="data">
                  <div>
                    <a v-for="pos in data.item.position" :key="pos"
                      href="javascript: void(0);"
                      class="badge badge-primary font-size-11 mr-2"
                    >
                      {{pos}}
                    </a>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="formItemsCurrentPage" :total-rows="formItemsTotalRows" :per-page="formItemsPerPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!--/Row-->
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            name: 'billingRulesComponent',
            formItemsPerPage: 10,
            formItemsTotalRows: 1,
            formItemsCurrentPage: 1,
            formItemsPageOptions: [10, 25, 50, 100],
            formItemsFilter: null,
            formItemsFilterOn: [],
            formItemsSortBy: "order",
            formItemsSortDesc: false,
            formItemsFields: [
              { key: 'edit', sortable: false },
              { key: 'order', sortable: true },
              { key: "name", sortable: true },
              { key: "label", sortable: true },
              { key: "type", sortable: true },
              { key: "mobile", sortable: true },
              { key: "web", sortable: true },
              { key: "required", sortable: true },
            ],
            formItemsTableData: [],
        }
    }
}
</script>